

import React, {Component} from "react";

class PCBQty extends Component{

    render() {
        return(
            <div className="container-fluid">
                最終基板製造コストを削減のため、独自製造ラインを構築しております、お客様にはご不便をおかけしますが、発注枚数はプルダウンメニューに記載しております枚数でお選びください。
                1.0mm以上の場合、板厚公差は±10％です。


            </div>
        );
    }
}
export default PCBQty;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQty.js